export type TRefundSection = {
  key: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
};

export const REFUND_SECTIONS: readonly TRefundSection[] = [
  { key: 'standard.products', paragraphs: ['line1', 'line2', 'line3'] },
  {
    key: 'custom.products',
    paragraphs: ['line1', 'line2', 'line3'],
    bullets: ['item1', 'item2'],
  },
  { key: 'return.costs', paragraphs: ['line1'] },
  { key: 'refund.method', paragraphs: ['line1'] },
] as const;
